import { MetadataInfoFooter, STATUSPAGE } from '@repo/ui';
import classnames from 'classnames';
import {
  GetAllPersonProfileUseCaseInterface,
  GetPersonByIdV2UseCaseInterface,
} from 'domain/usecases';
import { ContentState } from 'presentation/app/components/content-state';
import { useState } from 'react';
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from 'reactstrap';

import { usePersonForm } from '../../../hooks/usePersonForm';
import { PersonChangePasswordSubTab } from './sub-tabs-content/person-change-password-sub-tab';
import { PersonEditFormSubTab } from './sub-tabs-content/person-edit-form-sub-tab';
import { PersonProfilesSubTab } from './sub-tabs-content/person-profiles-sub-tab';

type ITab = {
  id: string;
  label: string;
  tabContent: JSX.Element;
};

interface IPersonRegisterTabProps {
  person: GetPersonByIdV2UseCaseInterface.Result;
  isLoading: boolean;
  personProfiles: GetAllPersonProfileUseCaseInterface.Result;
  requestGetPersonById: (
    params: GetPersonByIdV2UseCaseInterface.Params,
  ) => void;
  requestGetAllPersonProfile: (
    params: GetAllPersonProfileUseCaseInterface.Params,
  ) => void;
}

export const PersonRegisterTab = ({
  person,
  isLoading,
  personProfiles,
  requestGetPersonById,
  requestGetAllPersonProfile,
}: IPersonRegisterTabProps) => {
  const [activeTab, setActiveTab] = useState<string>('1');

  const { validation, loadingUpdatePerson } = usePersonForm({
    person,
    requestGetPersonById,
  });

  const tabs: ITab[] = [
    {
      id: '1',
      label: 'Dados Cadastrais',
      tabContent: (
        <PersonEditFormSubTab
          validation={validation}
          isLoading={loadingUpdatePerson}
          personHashId={person?.id}
          onCpfChanged={() => requestGetPersonById({ id: person?.id })}
        />
      ),
    },
    {
      id: '2',
      label: 'Segurança',
      tabContent: (
        <PersonChangePasswordSubTab
          personStatus={!person?.active}
          recentLogins={person?.security?.recentLogin}
        />
      ),
    },
    {
      id: '3',
      label: 'Perfis',
      tabContent: (
        <PersonProfilesSubTab
          profiles={personProfiles}
          requestGetAllPersonProfile={requestGetAllPersonProfile}
        />
      ),
    },
  ];

  return (
    <Col md={12} className="mt-5">
      <Card className="mb-1">
        <CardHeader>
          <Nav className="nav-tabs-custom rounded card-header-tabs border-bottom-0">
            {tabs.map((tab, index) => (
              <NavItem key={index}>
                <NavLink
                  style={{ cursor: 'pointer' }}
                  className={classnames({
                    active: activeTab === tab.id,
                  })}
                  onClick={() => setActiveTab(tab.id)}
                >
                  {tab.label}
                </NavLink>
              </NavItem>
            ))}
          </Nav>
        </CardHeader>

        <CardBody className="p-4">
          {isLoading ? (
            <ContentState
              status={STATUSPAGE.LOADING}
              className="border-0 shadow-none mb-0"
              minHeight={360}
            />
          ) : (
            <TabContent activeTab={activeTab}>
              {tabs.map((tab) => (
                <TabPane key={tab.id} tabId={tab.id}>
                  {tab.tabContent}
                </TabPane>
              ))}
            </TabContent>
          )}
        </CardBody>
      </Card>

      {activeTab === '1' && !isLoading && (
        <div className="py-2 pb-3">
          <MetadataInfoFooter
            metadata={{
              createdAt: person?.createdInfo?.createdAt,
              lastUpdater: person?.updatedInfo?.updatedBy?.name,
              updatedAt: person?.updatedInfo?.updatedAt,
            }}
          />
        </div>
      )}
    </Col>
  );
};
